// extracted by mini-css-extract-plugin
module.exports = {"landing":"K0xWRjHrhmoYzTARTCDfpA==","checkLabel":"EncxxKnJWFygu9YinkAR4Q==","icon":"_1w9-JtAVEU-p47fiNzHL6g=="};